import React from 'react';
import {
  IconServer,
  IconDownload,
  IconActivity,
  IconUpload
} from '@tabler/icons-react';
import { formatBytes, formatTraffic } from '../../utils/format';

const OverviewStatsCards = ({ stats, clientStats }) => {
  const activeCount = stats?.active_tunnels || 0;
  const totalTrafficMB = stats?.total_traffic_mb || 0;

  const cards = [
    {
      icon: IconServer,
      label: 'Активные туннели',
      value: activeCount,
      color: 'primary'
    },
    {
      icon: IconDownload,
      label: 'Трафик',
      value: formatTraffic(totalTrafficMB),
      color: 'blue'
    },
    {
      icon: IconActivity,
      label: 'Активных сейчас',
      value: clientStats.active,
      color: 'green'
    },
    {
      icon: IconUpload,
      label: 'Вх/Исх трафик',
      value: formatBytes(clientStats.totalBytesIn + clientStats.totalBytesOut),
      color: 'orange'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <div key={idx} className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-xl p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-600 dark:text-dark-400 text-xs">{card.label}</p>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-1">{card.value}</h3>
            </div>
            <div className={`w-8 h-8 bg-${card.color}-500/10 rounded-lg flex items-center justify-center`}>
              <card.icon className={`w-4 h-4 text-${card.color}-500`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewStatsCards;
